import { GET_ASSIGN_DRIVER_REQUESTED, GET_CANCEL_TRIP_REQUESTED, GET_INVOICE_DOWNLOAD_REQUESTED, GET_INVOICE_REQUESTED, GET_SOS_ALERT_REQUESTED, GET_TRIP_REQUESTED, GET_SHARE_TRIP_REQUESTED } from "resources/actionTypes";

export function getTrip(data) {
  return {
    type: GET_TRIP_REQUESTED,
    payload:data
  };
}
export function getSosAlert(data) {
  return {
    type: GET_SOS_ALERT_REQUESTED,
    payload:data
  };
}
export function postCancelTrip(data) {
  return {
    type: GET_CANCEL_TRIP_REQUESTED,
    payload:data
  };
}
export function getAssignDriver(data) {
  return {
    type: GET_ASSIGN_DRIVER_REQUESTED,
    payload:data
  };
}
export function getInvoice(data) {
  return {
    type: GET_INVOICE_REQUESTED,
    payload:data
  };
}
export function getInvoiceDownload(data) {
  return {
    type: GET_INVOICE_DOWNLOAD_REQUESTED,
    payload:data
  };
}


//migrated ShareTrip Action
export function shareTrip(data){
  return {
    type: GET_SHARE_TRIP_REQUESTED,
    payload:data
  }
}